import * as React from 'react';
import {connect} from 'react-redux';
import {IFamilyMember} from '@app-types/websocket/family.types';
import * as EconomyActions from '@services/economy/economy.actions';
import {economyStyle} from './economy.style';
import withStyles, {WithStyles} from '@material-ui/core/styles/withStyles';
import CameraIcon from "@material-ui/icons/CameraAltOutlined";
import LibraryIcon from "@material-ui/icons/LibraryAdd";
import MoneyIcon from "@material-ui/icons/LocalAtmRounded";
import BuyIcon from '@material-ui/icons/ShoppingCartOutlined';
import RepeatIcon from '@material-ui/icons/LoopRounded';
import * as FileActions from '@services/file/file.actions';
import * as EventActions from '@services/events/event.action';
import SuggestionIcon from '@material-ui/icons/HelpOutlineRounded';
import {
  EcoAgreementStatus,
  IEcoAgreement,
  IEcoPurchase,
  IEcoTransfer,
  IEndEcoAgreement,
  INewEcoAgreement,
  INewEcoPurchase,
  IRespondEcoAgreement,
  IRespondEcoAgreementUpdate,
  IUpdateEcoAgreement,
  IUpdateEcoPurchase,
  IUpdateEcoTransfer,
  INewEcoTransfer,
  EcoTransferMethod,
  IEcoSplitSetting,
  IEcoSetting
} from '@app-types/websocket/economy.types';
import EcoFloatingButton from '@components/economy/EcoFloatingButton';
import AgreementDialog from '@components/economy/AgreementDialog';
import ContainerApprovedAgreements from "@components/economy/ContainerApprovedAgreements";
import ContainerReceivedAgreements from "@components/economy/ContainerReceivedAgreements";
import ContainerSentAgreements from "@components/economy/ContainerSentAgreements";
import StackedNotifications from "@components/economy/StackedNotifications";
import {IEcoMonthlyPurchases} from './economy.internal.types';
import ContainerDoneTransactions from '@components/economy/ContainerDoneTransactions';
import PurchaseDialog from '@components/economy/PurchaseDialog';
import TransferDialog from '@components/economy/TransferDialog';
import Balance from '@components/economy/Balance';
import { FamilyMemberType } from '@services/family/family.constants';
import ContainerDisputedTransactions from '@components/economy/ContainerDisputedTransactions';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import AgreementSetupDialog from '@components/economy/setup/AgreementSetupDialog';
import { Tab, Tabs } from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import BottomBar from '@components/calendar2/fab/BottomBar';
import { getAgreementNotificationCount, getPurchaseBalance, getTransferBalance, getTransferBookingDate } from '@helpers/EconomyHelper';
import {clearPendingEcoTransfer, loadPendingEcoTransfer, savePendingEcoTransfer} from '@helpers/PendingEcoTransfer';
import BalanceSettings from '@components/economy/BalanceSettings';
import EconomyMenu from '@components/economy/EconomyMenu';
import {saveEconomy} from '@services/economy/economy.websocket';
import * as UserActions from '@services/user/user.actions';
import { IUploadFile, IStuffBeingUploaded, IFinishedUpload } from '@app-types/websocket/file.types';
import { AI_ANALYZE_TASK_TYPE, AI_RESULT, IAnalysedImage, IAnalysedReceipt } from '@app-types/websocket/event.types';
import { getPicture } from '@helpers/cameraHelper';
import { handleBlobUpload, fileToBase64 } from '@helpers/uploadHelper';

const tn: TranslateNew = TranslateNew.getInstance();

interface IRouteParams {
  transactionId?: string;
}

interface IProps extends RouteComponentProps, WithStyles<typeof economyStyle>
{
  displaySuccessMessage: (message: string) => void;
  displayErrorMessage: (message: string) => void;
  uploadFile: (file: IUploadFile) => void;
  uploadingFiles: IStuffBeingUploaded[];
  uploadedFiles: IFinishedUpload[];
  uploadedFileUsed: (fileId: number) => void;
  analyzeImage: (fileId: number) => void;
  dismissAnalyzedImage : (aiID:number) => void;
  analyzedFiles: IAnalysedImage[];

  userId: number;
  familyKey: string;
  family: IFamilyMember[];

  agreements: IEcoAgreement[];
  purchases: IEcoPurchase[];
  transfers: IEcoTransfer[];

  shouldPay:boolean;

  myPercentage:number;
  settings:IEcoSplitSetting[];
  currency:string;

  paymentMethod:"SWISH"|"VENMO"|"CASHAPP"|"PAYPAL",
  swishF1: string ;
  swishF2: string ;
  venmoF1: string ;
  venmoF2: string ;
  cashappF1: string ;
  cashappF2: string ;
  paypalF1: string ;
  paypalF2: string ;

  newAgreement: (data: INewEcoAgreement) => void;
  updateAgreement: (update: IUpdateEcoAgreement) => void;
  respondAgreement: (response: IRespondEcoAgreement) => void;
  respondAgreementUpdate: (response: IRespondEcoAgreementUpdate) => void;
  endAgreement: (agreement: IEndEcoAgreement) => void;
  archiveAgreement: (agreementId: number) => void;
  archiveAgreementUpdate: (agreementId: number) => void;
  seenAgreement: (agreementId: number) => void;

  newPurchase: (data: INewEcoPurchase) => void;
  updatePurchase: (update: IUpdateEcoPurchase) => void;
  deletePurchase: (purchaseId: number) => void;
  restorePurchase: (purchaseId: number) => void;
  disputePurchase: (purchaseId: number) => void;
  seenPurchase: (purchaseId: number) => void;
  archivePurchase: (purchaseId: number) => void;

  newTransfer: (data: INewEcoTransfer) => void;
  updateTransfer: (update: IUpdateEcoTransfer) => void;
  deleteTransfer: (transferId: number) => void;
  restoreTransfer: (transferId: number) => void;
  archiveTransfer: (transferId: number) => void;
  seenTransfer: (transferId: number) => void;
  disputeTransfer: (transferId: number) => void;

  updateEcoSettings:(settings:IEcoSetting[]) => void;
}

interface IState
{
  errorMessage:string;
  dataUrl:string|undefined;
  internalId:number[];      // uploaded files stuff
  aiReceipt?:IAnalysedReceipt;

  settingsOpen:boolean;

  editAgreement?:IEcoAgreement;
  isAddNewAgreementOpen: boolean;
  isAddNewAgreementRequest: boolean;

  completeAgreement?:IEcoAgreement;
  editPurchase?:IEcoPurchase;
  isAddNewPurchaseOpen: boolean;

  editTransfer?:IEcoTransfer;
  isAddNewTransferOpen: boolean;
  transferSum?:number;
  transferMethod?:EcoTransferMethod;

  approvedAgreements:IEcoAgreement[];
  receivedAgreements:IEcoAgreement[];
  sentAgreements :IEcoAgreement[];
  snackbarAgreements :IEcoAgreement[];

  donePurchases:IEcoMonthlyPurchases[];
  disputedPurchases:IEcoPurchase[];
  disputedByMePurchases:IEcoPurchase[];

  unseenPurchases:IEcoPurchase[];
  removedPurchases:IEcoPurchase[];

  unseenTransfers:IEcoTransfer[];
  removedTransfers:IEcoTransfer[];
  disputedTransfers:IEcoTransfer[];
  disputedByMeTransfers:IEcoTransfer[];

  scrollTime:number;

  doScroll:boolean;

  externallyGivenAgreement?:number;
  externallyGivenPurchase?:number;
  externallyGivenTransfer?:number;

  waitForAgreementChat?:number;
  waitForPurchaseChat?:number;
  waitForTransferChat?:number;

  showGuide:boolean;

  scrollBullet:0|1;
  hideFab:boolean;
}

class EconomyContainer extends React.Component<IProps, IState> {
  private scrollPaneRef: React.RefObject<HTMLDivElement> = React.createRef();
  private timer = setTimeout(() => {return;}, 500);

  constructor(props: IProps)
  {
    super(props);
    const pendingTransfer = loadPendingEcoTransfer(props.userId);
    this.state = {
      errorMessage:"",
      dataUrl:undefined,
      internalId:[],

      settingsOpen:false,
      editAgreement:undefined,
      isAddNewAgreementOpen: false,
      isAddNewAgreementRequest: false,

      completeAgreement:undefined,
      editPurchase:undefined,
      isAddNewPurchaseOpen:false,

      editTransfer:undefined,
      isAddNewTransferOpen: pendingTransfer !== undefined,
      transferSum:pendingTransfer && pendingTransfer.sum,
      transferMethod:pendingTransfer && pendingTransfer.method,

      scrollTime: 0,
      doScroll:false,
      scrollBullet: 0,

      showGuide: false,
      hideFab: false,
      ...this.sortAgreements(props.agreements),
      ...this.sortPurchases(props.purchases, props.transfers),
    };
  }

  public componentDidUpdate(oldProps:IProps, oldState:IState) {
    if (this.state.waitForAgreementChat) {
      const agreement = this.props.agreements.find((ag) => ag.id === this.state.waitForAgreementChat);
      if (agreement && agreement.chatId !== undefined) {
        this.setState({waitForAgreementChat:undefined});
        this.props.history.push(`/app/messages/${agreement.chatId}`);
      }
    }
    if (this.state.waitForPurchaseChat) {
      const purchase = this.props.purchases.find((ag) => ag.id === this.state.waitForPurchaseChat);
      if (purchase && purchase.chatId !== undefined) {
        this.setState({waitForPurchaseChat:undefined});
        this.props.history.push(`/app/messages/${purchase.chatId}`);
      }
    }
    if (this.state.waitForTransferChat) {
      const transfer = this.props.transfers.find((ag) => ag.id === this.state.waitForTransferChat);
      if (transfer && transfer.chatId !== undefined) {
        this.setState({waitForTransferChat:undefined});
        this.props.history.push(`/app/messages/${transfer.chatId}`);
      }
    }
      
    if (this.props.agreements !== oldProps.agreements) {
      this.setState(this.sortAgreements(this.props.agreements));
    }
    if (this.props.purchases !== oldProps.purchases || this.props.transfers !== oldProps.transfers) {
      this.setState(this.sortPurchases(this.props.purchases, this.props.transfers));
    }
    if ((oldProps.uploadingFiles !== this.props.uploadingFiles || oldProps.uploadedFiles !== this.props.uploadingFiles)) {

      for (const f of this.props.uploadingFiles) {
        if (f.loaded === 100 && this.state.internalId.includes(f.internalId)) {

          const newInternal = this.state.internalId.filter((id) => id !== f.internalId);
          this.setState({internalId:newInternal, dataUrl:undefined});
          this.props.uploadedFileUsed(f.id);
          this.props.analyzeImage(f.id);
        }
      }
      for (const f of this.props.uploadedFiles) {
        if (this.state.internalId.includes(f.internalId)) {

          const newInternal = this.state.internalId.filter((id) => id !== f.internalId);
          this.setState({internalId:newInternal, dataUrl:undefined});
          this.props.uploadedFileUsed(f.id);
          this.props.analyzeImage(f.id);
        }
      }
    }
    if (oldState.dataUrl !== this.state.dataUrl && this.state.dataUrl !== undefined) {
      const img = new Image();
      const data:string = this.state.dataUrl;

      img.onload = () => {

        let newImgWidth = img.width;
        let newImgHeight = img.height;
      
        if (img.width >= img.height && img.width > 1200) {
          newImgWidth = 1200;
          newImgHeight = Math.floor(((1200*img.height)/img.width));
        } else if (img.height > img.width && img.height > 1200) {
          newImgHeight = 1200;
          newImgWidth = Math.floor(((1200*img.width)/img.height));
        }

        setTimeout(() => {this.upload(img, newImgWidth, newImgHeight)}, 300); // upload image
      };
      img.onerror = (error) => {
        this.setState({errorMessage:"Error reading image"});
      };

      img.src = data;
    }
  }

  public upload(img: HTMLImageElement, width:number, height:number) {
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    // don't paint a border here, as it is the resulting image
    const context = canvas.getContext('2d')!;
    context.save()

    context.globalCompositeOperation = 'destination-over';
    context.drawImage(img,0,0,width,height,);
    context.restore()
    canvas.toBlob((blob) => {
      if(blob){
        const fileUpload = handleBlobUpload(blob,"receipt.png",this.props.uploadFile);
        const internalIds = this.state.internalId.slice();
        internalIds.push(fileUpload.internalId);
        this.setState({internalId:internalIds});
      }
    })
  }

  public componentDidMount() {
    const { transactionId } = this.props.match.params as IRouteParams;

    if (transactionId) {
      if (transactionId.startsWith("a")) {
        this.scroll(1);
        // console.log("agreement");
      } else if (transactionId.startsWith("p")) {
        this.scroll(0);
        // console.log("purchase");
      }  else if (transactionId.startsWith("t")) {
        this.scroll(0);
        // console.log("transfer");
      }
    }
  }

  public toggleAddNewAgreementDialog = (request:boolean) =>
  {
    this.setState({isAddNewAgreementOpen: true, isAddNewAgreementRequest:request});
  }

  public toggleEditAgreementDialog = (agreement:IEcoAgreement) =>
  {
    this.setState({editAgreement:agreement, isAddNewAgreementRequest:false});
  }

  public toggleAddNewPurchaseDialog = () =>
  {
    this.setState({isAddNewPurchaseOpen: true});
  }

  public toggleEditPurchaseDialog = (purchase:IEcoPurchase) =>
  {
    this.setState({editPurchase:purchase});
  }

  public render()
  {


    const { isAddNewAgreementOpen,approvedAgreements,receivedAgreements, doScroll, disputedTransfers,
      sentAgreements,snackbarAgreements,editAgreement,donePurchases,editTransfer, disputedPurchases,
      disputedByMePurchases, disputedByMeTransfers,
      isAddNewPurchaseOpen, editPurchase, completeAgreement, isAddNewTransferOpen,} = this.state;
    const { respondAgreement, respondAgreementUpdate, settings, updateEcoSettings, family, classes , currency} = this.props;

    let parents = 0;
    for (const mem of family) {
      if (mem.role === FamilyMemberType.PARENT) {
        parents++;
      }
    }

    let unseenExecuted = 0;

    if (this.props.shouldPay) {
      unseenExecuted++;
    }

    for (const p of this.props.purchases) {
      if (!p.archivedBy.includes(this.props.userId) && !p.seenBy.includes(this.props.userId) && p.disputedBy === undefined) {
        unseenExecuted += 1;
      }
    }
    for (const t of this.props.transfers) {
      if (!t.archivedBy.includes(this.props.userId) && !t.seenBy.includes(this.props.userId) && t.disputedBy === undefined) {
        unseenExecuted += 1;
      }
    }

    const unHandledAgreements = getAgreementNotificationCount(this.props.agreements, this.props.userId);

    const disputed = disputedPurchases.length + disputedByMePurchases.length;

    if (parents < 2) {
      return (<div>not working... (only one parent exists)</div>);
    }

    let badgeContent = 0;
    if (this.props.paymentMethod === undefined || this.props.paymentMethod.length < 1) {
      badgeContent = 1;
    } else if (this.props.paymentMethod === "SWISH" && (this.props.swishF1.trim().length < 3 || this.props.swishF2.trim().length < 3)) {
        badgeContent = 1;
    } else if (this.props.paymentMethod === "VENMO" && (this.props.venmoF1.trim().length < 3 || this.props.venmoF2.trim().length < 3)) {
        badgeContent = 1;
    } else if (this.props.paymentMethod === "CASHAPP" && (this.props.cashappF1.trim().length < 3 || this.props.cashappF2.trim().length < 3)) {
        badgeContent = 1;
    } else if (this.props.paymentMethod === "PAYPAL" && (this.props.paypalF1.trim().length < 3 || this.props.paypalF2.trim().length < 3)) {
        badgeContent = 1;
    }



    let haveResult:boolean = false;
    let resultId:number = 0;
    let errorMessage:string = "";
    let errorId:number = 0;
    let isAnalyzing:boolean = false;
    const isUploading:boolean = this.state.internalId.length > 0;

    for (const result of this.props.analyzedFiles) {
      if ((result.result === AI_RESULT.FAIL || result.result === AI_RESULT.NO_DATA) && result.dismissed !== true) {
        if (result.errorMsg && result.errorMsg !== "") {
          errorMessage = result.errorMsg;
        } else {
          errorMessage = "Ai analysis failed"
        }
        errorId = result.id;
      } else if ((result.result === AI_RESULT.SUCCESS) && result.dismissed !== true) {
        haveResult = true;
        resultId = result.id;
      } else if (result.result === AI_RESULT.IN_PROGRESS && result.dismissed !== true ) {
        isAnalyzing = true;
      }
    }

    let aiOptions: Array<{label: JSX.Element; action: () => void;}> = [];
    let aiUpdateLocalFile: ((event: any) => void) | undefined;
    let aiSpecialStyle:"ANALYZE"|"READY"|"FAIL"|undefined;

    if (haveResult) {
      aiOptions = [{label: <div>Ai</div>, action: () => {this.showReceipts(resultId)}}]
      aiSpecialStyle = "READY";
    } else if (errorMessage !== "") {
      aiOptions = [{label: <div>{tn.lang.error}</div>, action: () => {this.props.dismissAnalyzedImage(errorId)}}]
      aiSpecialStyle = "FAIL";
    } else if (isAnalyzing) {
      aiOptions = [{label: <div>Ai</div>, action: () => {return;}}]
      aiSpecialStyle = "ANALYZE";
    } else if (isUploading) {
      aiOptions = [{label: <div>Ai</div>, action: () => {return;}}]
      aiSpecialStyle = "ANALYZE";
    } else if (false) {
      aiOptions=[
        {label:<><CameraIcon /><div>{tn.lang.camera}</div></>, action:() => this.loadImage("CAMERA")},
        // {label:<><LibraryIcon /><div>{tn.lang.library}</div></>, action:() => this.loadImage("LIBRARY")}
      ];
    } else {
      aiUpdateLocalFile = (event) => this.updateLocalFile(event);
    }
    

    return (<div className={classes.mainContainer}>
        <div className={classes.tabs}>
          <div className={classes.containerTop}><div className={classes.containerCorners} /></div>
          <Tabs
            value={this.state.scrollBullet}
            onChange={(event, value) => {
            this.setState({scrollBullet: value, scrollTime: Date.now()});
            this.scroll(value);
          }}
            classes={{
              indicator: classes.tabsIndicator
            }}
          >
            <Tab
              label={
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <div>{tn.lang.economyDone}</div>
                  <div className={classes.badge} style={{marginLeft: '3px',display: (unseenExecuted > 0 ? undefined : 'none')}}>
                    {unseenExecuted}
                  </div>
                </div>}
            />
            <Tab
              label={
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <div>{tn.lang.economyAgree}</div>
                  <div className={classes.badge} style={{marginLeft: '3px',display: ((disputed+ unHandledAgreements) > 0 ? undefined : 'none')}}>
                    {disputed+unHandledAgreements}
                  </div>
                </div>}
            />
          </Tabs>
          <div style= {{ position: 'absolute',top: '0px',right: '0px'}}>
            <EconomyMenu key={this.props.familyKey} badgeContent={badgeContent}
              onSettings={() => this.setState({settingsOpen: true})}
              onDownload={() => {
                if (saveEconomy()) {this.props.displaySuccessMessage(tn.lang.ecoExportEmailQueued);}
                else {this.props.displayErrorMessage(tn.lang.ecoExportOffline);}
              }} />
          </div>
        </div>
        <div ref={this.scrollPaneRef}
             className={classes.horizontalController}
             onScroll={() => {
               clearTimeout(this.timer);
               this.timer = setTimeout(() => this.checkScrollPos(), 200);
             }}>
          


          <div className={classes.infobankColumn} onScroll={() => 
            {clearTimeout(this.timer); this.timer = setTimeout(() => this.setState({scrollTime:Date.now()}), 200); }}>
            {/* done stuff */}

            <div className={classes.container} >
              
              <Balance userId={this.props.userId} purchases={donePurchases}
                showSettings={() => this.setState({settingsOpen:true})}
                onNewTransfer={(sum:number, method:EcoTransferMethod) => 
                  this.openPendingTransfer(sum, method)}/>

              {donePurchases.length > 0 
                && (<ContainerDoneTransactions userId={this.props.userId} edit={(purchase) => this.setState({editPurchase:purchase})}
                editTransfer={(transfer) => this.setState({editTransfer:transfer})} settings={this.props.settings} currency={currency}
                waitForTransferChat={(id) => this.waitForTransferChat(id)} waitForPurchaseChat={(id) => this.waitForPurchaseChat(id)}
                family={this.props.family} transactionsByMonth={donePurchases} purchases={this.props.purchases} transfers={this.props.transfers}
                seen={this.props.seenPurchase} seenTransfer={this.props.seenTransfer} scrollTime={this.state.scrollTime}
                />)}

              {donePurchases.length  === 0 
                && (<div style={{display:'flex', flexDirection:'column', position: 'absolute', bottom: 'calc(50% - 200px)', 
                  left: 'calc(50% - 120px)', width:'240px', alignItems:'center'}}>
                  <p className={classes.helpText}>{tn.lang.ecoDoneHelp1}</p>
                  <img src={'arrow.png'} style={{ width: '60px'}} alt="Arrow" />
                </div>)}
              <EcoFloatingButton hide={this.state.hideFab} style={{right: '20px', bottom:'182px'}}
                specialStyle={aiSpecialStyle}
                isAi={true} 
                updateLocalFile={aiUpdateLocalFile}
                options={aiOptions}/> 
              <EcoFloatingButton hide={this.state.hideFab} style={{right: '20px'}} 
                options={[
                  {label:<><BuyIcon /><div>{tn.lang.purchase}</div></>, action:() => this.toggleAddNewPurchaseDialog()},
                  {label:<><MoneyIcon /><div>{tn.lang.transfer}</div></>, action:() => 
                    this.setState({transferSum:0, transferMethod:EcoTransferMethod.BANK, isAddNewTransferOpen:true})}
                ]}/> 
            </div>
          </div>

          <div className={classes.infobankColumn} onScroll={() => 
            {clearTimeout(this.timer); this.timer = setTimeout(() => this.setState({scrollTime:Date.now()}), 200); }}>             
            {/* requests stuff */}

            <div className={classes.container} >

              {(approvedAgreements.length === 0 && disputedByMePurchases.length === 0 && disputedByMeTransfers.length === 0
              && disputedPurchases.length === 0 && disputedTransfers.length === 0
              && receivedAgreements.length === 0 && sentAgreements.length === 0 ) && 
                <div style={{display:'flex', flexDirection:'column', position: 'absolute', top: '100px', 
                  left: 'calc(150% - 120px)', width:'240px', alignItems:'center'}}>
                  <p className={classes.helpText}>{tn.lang.ecoSuggHelp1}</p>
                  <p className={classes.helpText}>{tn.lang.ecoSuggHelp2}</p>
                  <p className={classes.helpText}>{tn.lang.ecoSuggHelp3}</p>
                  <img src={'arrow.png'} style={{ width: '60px'}} alt="Arrow" />
                </div>
              }

              {(disputedByMePurchases.length > 0 || disputedByMeTransfers.length > 0)
                && (<ContainerDisputedTransactions userId={this.props.userId} edit={(purchase) => this.setState({editPurchase:purchase})}
                editTransfer={(transfer) => this.setState({editTransfer:transfer})} settings={this.props.settings} currency={currency}
                waitForTransferChat={(id) => this.waitForTransferChat(id)} waitForPurchaseChat={(id) => this.waitForPurchaseChat(id)}
                family={this.props.family} disputedTransfers={disputedByMeTransfers} disputedPurchases={disputedByMePurchases} doScroll={doScroll}
                seen={this.props.seenPurchase} seenTransfer={this.props.seenTransfer} scrollTime={this.state.scrollTime} disputedByMe={true}
                />)}

              {(disputedPurchases.length > 0 || disputedTransfers.length > 0)
                && (<ContainerDisputedTransactions userId={this.props.userId} edit={(purchase) => this.setState({editPurchase:purchase})}
                editTransfer={(transfer) => this.setState({editTransfer:transfer})} settings={this.props.settings} currency={currency}
                waitForTransferChat={(id) => this.waitForTransferChat(id)} waitForPurchaseChat={(id) => this.waitForPurchaseChat(id)}
                family={this.props.family} disputedTransfers={disputedTransfers} disputedPurchases={disputedPurchases} doScroll={doScroll}
                seen={this.props.seenPurchase} seenTransfer={this.props.seenTransfer} scrollTime={this.state.scrollTime} disputedByMe={false}
                />)}

              {receivedAgreements.length > 0
                && (<ContainerReceivedAgreements family={this.props.family} edit={(agreement:IEcoAgreement) => 
                  {this.setState({editAgreement:agreement});}}
                currency={currency} scrollTime={this.state.scrollTime} seen={this.props.seenAgreement}
                waitForAgreementChat={(id) => this.waitForAgreementChat(id)}
                agreements={receivedAgreements} respond={respondAgreement} respondChange={respondAgreementUpdate} userId={this.props.userId}/>)}
                
              {sentAgreements.length > 0 
                && (<ContainerSentAgreements edit={(agreement:IEcoAgreement) => {this.setState({editAgreement:agreement});}}
                currency={currency} scrollTime={this.state.scrollTime} seen={this.props.seenAgreement}
                family={this.props.family} agreements={sentAgreements} respond={respondAgreement} 
                waitForAgreementChat={(id) => this.waitForAgreementChat(id)}
                respondChange={respondAgreementUpdate} userId={this.props.userId} />)}

              <ContainerApprovedAgreements userId={this.props.userId} currency={currency}
                toggleSetupWizard={() => this.setState({showGuide:true})}
                complete={(agreement:IEcoAgreement) => {this.setState({completeAgreement:agreement});}}
                edit={(agreement:IEcoAgreement) => {this.setState({editAgreement:agreement});}}
                seen={this.props.seenAgreement} scrollTime={this.state.scrollTime}
                family={this.props.family} agreements={approvedAgreements}
                />

              <div style={{minWidth:'100px', minHeight:'100px'}} />
              
              <EcoFloatingButton hide={this.state.hideFab} style={{right: 'calc(-100% + 20px)'}} 
                options={[{label:<><SuggestionIcon /><div>{tn.lang.ecoSuggestion}</div></>, action:() => this.toggleAddNewAgreementDialog(true)},
                  {label:<><RepeatIcon /><div>{tn.lang.ecoRecurring}</div></>, action:() => this.toggleAddNewAgreementDialog(false)}]}/>   
            </div>
                   
          </div>

          <StackedNotifications
            agreementsThatNeedArchive={snackbarAgreements}
            archiveAgreement={this.props.archiveAgreement}
            archiveAgreementUpdate={this.props.archiveAgreementUpdate}
            purchasesThatNeedSeen={this.state.unseenPurchases}
            seenPurchase={this.props.seenPurchase}
            purchasesThatNeedArchive={this.state.removedPurchases}
            archivePurchase={this.props.archivePurchase}
            archiveTransfer={this.props.archiveTransfer}
            seenTransfer={this.props.seenTransfer}
            transfersThatNeedArchive={this.state.removedTransfers}
            transfersThatNeedSeen={this.state.unseenTransfers}
            userId={this.props.userId}
            showTransfer={this.showTransfer}
            showAgreement={this.showAgreement}
            showPurchase={this.showPurchase}
          />
        </div>
        <BalanceSettings
            settingsOpen={this.state.settingsOpen}
            family={this.props.family}
            userId={this.props.userId}
            updateEcoSettings={this.props.updateEcoSettings}
            onClose={() => this.setState({ settingsOpen: false })}
        />
        <BottomBar 
          hidden={false}
          displaySubmenyCallback={(hideF:boolean) => {this.setState({hideFab:hideF})}}
        />
        <AgreementDialog isOpen={(isAddNewAgreementOpen || editAgreement !== undefined)} isRequest={this.state.isAddNewAgreementRequest}
          onDelete={(agreementId:number, future:boolean) =>{this.setState({isAddNewAgreementOpen:false, editAgreement:undefined});
            this.props.endAgreement({agreementId, endChildSpawning:future, purchase:false});}}
          onClose={() => this.setState({isAddNewAgreementOpen:false, editAgreement:undefined})} 
          existingAgreement={this.state.editAgreement} currency={currency} settings={this.props.settings}
          waitForAgreementChat={(id) => this.waitForAgreementChat(id)}
          onEdit={(update:IUpdateEcoAgreement) => 
            {this.props.updateAgreement(update); this.setState({isAddNewAgreementOpen:false, editAgreement:undefined});}}
          onCreateNew={(agreement:INewEcoAgreement) => 
            {this.props.newAgreement(agreement); this.setState({isAddNewAgreementOpen:false, editAgreement:undefined});}} />

        <PurchaseDialog isOpen={(isAddNewPurchaseOpen || editPurchase !== undefined || completeAgreement !== undefined)} 
          aiPurchase={this.state.aiReceipt}
          onDelete={(aid:number) => {this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, 
            completeAgreement:undefined, aiReceipt:undefined});
            this.props.deletePurchase(aid);}}
          onRestore={(aid:number) => {this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, 
            completeAgreement:undefined, aiReceipt:undefined});
            this.props.restorePurchase(aid);}}
          showAgreement={(aid) => {this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, 
            completeAgreement:undefined, aiReceipt:undefined});
            setTimeout(() => {this.setState({editAgreement:this.props.agreements.find((a) =>a.id === aid)});},400);}} 
          onClose={() => this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, completeAgreement:undefined, aiReceipt:undefined})} 
          completedAgreement={completeAgreement} existingPurchase={editPurchase}
          settings={this.props.settings} currency={currency}
          waitForPurchaseChat={(id) => this.waitForPurchaseChat(id)}
          onChallenge={(purchaseId:number) => 
            {this.props.disputePurchase(purchaseId); this.scroll(1);
            this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, completeAgreement:undefined, doScroll:true, aiReceipt:undefined});}}
          onEdit={(update:IUpdateEcoPurchase) => 
            {this.props.updatePurchase(update); 
            this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, completeAgreement:undefined, aiReceipt:undefined});}}
          onCreateNew={(purchase:INewEcoPurchase) => 
            {this.props.newPurchase(purchase); 
            this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, completeAgreement:undefined, aiReceipt:undefined});}} />

        <TransferDialog isOpen={(isAddNewTransferOpen || editTransfer !== undefined)} currency={currency}
          onDelete={(transferId:number) =>{this.setState({isAddNewTransferOpen:false, editTransfer:undefined});
            this.props.deleteTransfer(transferId);}}
          onRestore={(transferId:number) =>{this.setState({isAddNewTransferOpen:false, editTransfer:undefined});
            this.props.restoreTransfer(transferId);}}
          onClose={() => this.closeTransferDialog()}
          existingTransfer={editTransfer}
          sum={this.state.transferSum}
          waitForTransferChat={(id) => this.waitForTransferChat(id)}
          method={this.state.transferMethod}
          onChallenge={(transferId:number) => 
            {this.props.disputeTransfer(transferId); this.scroll(1);
            this.setState({isAddNewPurchaseOpen:false, editPurchase:undefined, completeAgreement:undefined, doScroll:true});}}
          onEdit={(update:IUpdateEcoTransfer) => 
            {this.props.updateTransfer(update); this.setState({isAddNewTransferOpen:false, 
              editTransfer:undefined, transferSum:undefined, transferMethod:undefined});}}
          onCreateNew={(transfer:INewEcoTransfer) => 
            {this.props.newTransfer(transfer); this.closeTransferDialog();}} />

        <AgreementSetupDialog 
          settings={this.props.settings} 
          isOpen={this.state.showGuide}
          onClose={() => this.setState({showGuide:false})}
          currency={currency}
        />
      </div>
    );
  }

  private showReceipts(id:number) {
    let aiReceipt:IAnalysedReceipt|undefined;
    const image = this.props.analyzedFiles.find((a) => a.id === id)  
    if (image && image.receipts && image.receipts.length > 0) {
      aiReceipt = image.receipts[0];
    }
    this.setState({aiReceipt, isAddNewPurchaseOpen:true});
    this.props.dismissAnalyzedImage(id);
  }

  private loadImage(source:"CAMERA") {
    getPicture(source, (data) => this.imageLoaded(data), (error) => this.imageFailed(error));
  }

  private imageLoaded(blob:Blob) {
    const fileUpload = handleBlobUpload(blob,"analyze.jpeg",this.props.uploadFile);
    const internalIds = this.state.internalId.slice();
    internalIds.push(fileUpload.internalId);
    this.setState({internalId:internalIds});
  }

  private imageFailed(error:string) {
    this.setState({errorMessage:error});
    console.log(error);
  }

  private scroll(pane: number) {
    const elmnt = this.scrollPaneRef.current;
    if (elmnt !== null) {
      elmnt.scroll({top: 0, left: ((elmnt.scrollWidth * pane) / 2), behavior: 'smooth'});
    }
  }

  private checkScrollPos() {
    const elmnt = this.scrollPaneRef.current;
    if (elmnt !== null) {
      if (elmnt.scrollLeft <= elmnt.scrollWidth / 4) {
        this.setState({scrollBullet: 0, scrollTime: Date.now()});
      } else {
        this.setState({scrollBullet: 1, scrollTime: Date.now()});
      }
    }
  }

  private waitForAgreementChat = (agreementId:number) => {
    this.setState({waitForAgreementChat:agreementId});
  }
  private waitForPurchaseChat = (purchaseId:number) => {
    this.setState({waitForPurchaseChat:purchaseId});
  }
  private waitForTransferChat = (transferId:number) => {
    this.setState({waitForTransferChat:transferId});
  }

  private openPendingTransfer = (sum:number, method:EcoTransferMethod) => {
    savePendingEcoTransfer(this.props.userId, {sum, method});
    this.setState({transferSum:sum, transferMethod:method, isAddNewTransferOpen:true});
  }

  private closeTransferDialog = () => {
    if (this.state.isAddNewTransferOpen) {
      clearPendingEcoTransfer(this.props.userId);
    }
    this.setState({isAddNewTransferOpen:false, editTransfer:undefined, transferSum:undefined, transferMethod:undefined});
  }

  private showAgreement = (agreement:IEcoAgreement) => {
    if (agreement.status === EcoAgreementStatus.DELETED || agreement.status === EcoAgreementStatus.REJECTED) {
      this.setState({editAgreement:agreement});
    }
  }

  private showTransfer = (transfer:IEcoTransfer) => {
    if (transfer.deleted === true) {
      this.setState({editTransfer:transfer});
    }
  }

  private showPurchase = (purchase:IEcoPurchase) => {
    if (purchase.deleted === true) {
      this.setState({editPurchase:purchase});
    }
  }

  private sortAgreements = (agreements:IEcoAgreement[]) => {

    const approvedAgreements:IEcoAgreement[] =[];
    const receivedAgreements:IEcoAgreement[] =[];
    const sentAgreements :IEcoAgreement[] =[];
    const snackbarAgreements :IEcoAgreement[] =[];

    for(const agreement of agreements) {
      if ((agreement.status === EcoAgreementStatus.APPROVED || agreement.status === EcoAgreementStatus.PRE_APPROVED)
        && (!agreement.closed)
        && (agreement.pendingChange === undefined
          || agreement.pendingChange.status === EcoAgreementStatus.DELETED
          || agreement.pendingChange.status === EcoAgreementStatus.REJECTED)) {
        approvedAgreements.push(agreement);
      } else if (agreement.status === EcoAgreementStatus.AWAITING_RESPONSE ) {
        if (!agreement.responses.find(r => r.account === this.props.userId)) {
          receivedAgreements.push(agreement);
        } else {
          sentAgreements.push(agreement);
        }
      } else if (agreement.status === EcoAgreementStatus.APPROVED && agreement.pendingChange
        && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE) {
        if (!agreement.pendingChange.responses.find(r => r.account === this.props.userId)) {
          receivedAgreements.push(agreement);
        } else {
          sentAgreements.push(agreement);
        }
      } else if (agreement.status === EcoAgreementStatus.DELETED && !agreement.archivedBy.includes(this.props.userId)) {
        snackbarAgreements.push(agreement);
      } else if (agreement.status === EcoAgreementStatus.REJECTED && !agreement.archivedBy.includes(this.props.userId)) {
        snackbarAgreements.push(agreement);
      }

      // also display snackbar notification (and display in approved) for deleted pending changes
      if (agreement.pendingChange !== undefined
        && (agreement.pendingChange.status === EcoAgreementStatus.DELETED || agreement.pendingChange.status === EcoAgreementStatus.REJECTED)
        && !agreement.pendingChange.archivedBy.includes(this.props.userId)) {
          snackbarAgreements.push(agreement);
      }

    }
    return {approvedAgreements,receivedAgreements,sentAgreements,snackbarAgreements};
  }

  private sortPurchases = (purchases:IEcoPurchase[], transfers:IEcoTransfer[]) => {

    const disputedPurchases:IEcoPurchase[] = [];
    const disputedByMePurchases:IEcoPurchase[] = [];
    const unseenPurchases:IEcoPurchase[] = [];
    const removedPurchases:IEcoPurchase[] = [];

    const unseenTransfers:IEcoTransfer[] = [];
    const removedTransfers:IEcoTransfer[] = [];
    const disputedTransfers:IEcoTransfer[] = [];
    const disputedByMeTransfers:IEcoTransfer[] = [];

    const data:any = {};
    data.dataKeys = [];

    for(const purchase of purchases) {
      if (purchase.deleted === true) {
        if (!purchase.archivedBy.includes(this.props.userId)) {
          removedPurchases.push(purchase);
        }
        this.putPurchaseInCorrectMonth(purchase, data);
      } else if (purchase.disputedBy) {
        if (purchase.disputedBy === this.props.userId) {
          disputedByMePurchases.push(purchase);
        } else {
          disputedPurchases.push(purchase);
        }
      } else {
        this.putPurchaseInCorrectMonth(purchase, data);
      }
    }
    for(const transfer of transfers) {
      if (transfer.deleted === true) {
        if (!transfer.archivedBy.includes(this.props.userId)) {
          removedTransfers.push(transfer);
        }
        this.putTransferInCorrectMonth(transfer, data);
      } else if (transfer.disputedBy !== undefined) {
        if (transfer.disputedBy === this.props.userId) {
          disputedByMeTransfers.push(transfer);
        } else {
          disputedTransfers.push(transfer);
        }
      } else {
        this.putTransferInCorrectMonth(transfer, data);
      }
    }
    const donePurchases:IEcoMonthlyPurchases[] = [];
    data.dataKeys.sort((a:string,b:string) => 0 - (a > b ? 1 : -1));
    let isFirstMonth = true;
    for (const key of data.dataKeys) {
      donePurchases.push(data[key]);
      if (!isFirstMonth) {
        for (const p of data[key].purchases) {
          if ((!p.seenBy.includes(this.props.userId)) && p.deleted !== true) {
            unseenPurchases.push(p);
          }
        }
        for (const t of data[key].transfers) {
          if ((!t.seenBy.includes(this.props.userId)) && t.deleted !== true) {
            unseenTransfers.push(t);
          }
        }
      }
      isFirstMonth = false;
    }

    return { donePurchases, disputedPurchases, unseenPurchases, removedPurchases, unseenTransfers, removedTransfers, 
      disputedTransfers, disputedByMePurchases, disputedByMeTransfers};
  }

  private putPurchaseInCorrectMonth(purchase:IEcoPurchase, data:any) {
    const date:Date = new Date(purchase.date);
    const key:string = date.getFullYear()+(date.getMonth() < 10 ? '0' : '') + date.getMonth();
    let month:IEcoMonthlyPurchases;
    if (data.dataKeys.includes(key)) {
      month = data[key];
    } else {
      month = {
        month:date.getMonth(),
        year:date.getFullYear(),
        purchases:[],
        transfers:[],
      };
      data[key] = month;
      data.dataKeys.push(key);
    }
    month.purchases.push(purchase);
  }

  private putTransferInCorrectMonth(transfer:IEcoTransfer, data:any) {
    const date:Date = new Date(getTransferBookingDate(transfer));
    const key:string = date.getFullYear()+(date.getMonth() < 10 ? '0' : '') + date.getMonth();
    let month:IEcoMonthlyPurchases;
    if (data.dataKeys.includes(key)) {
      month = data[key];
    } else {
      month = {
        month:date.getMonth(),
        year:date.getFullYear(),
        transfers:[],
        purchases:[],
      };
      data[key] = month;
      data.dataKeys.push(key);
    }
    month.transfers.push(transfer);
  }

  private updateLocalFile = async (event: any) => {
    try {
      const { files } = event.target;
      if (files && files.length > 0 || (event.files && event.files.length > 0)) {
        const f:File = files.item(0) ? files.item(0) : event.files.item(0);
        if (f.type && f.type.toLowerCase().includes("image")) {
          const data = await fileToBase64(f);
          this.setState({dataUrl:  'data:'+f.type+';base64,'  + data});
        } else {
          this.setState({errorMessage:"Sorry we can't analyse that kind of data yet. "
            + "Please send us a chat message and tell us what you want to do!"});
        }
      }
    } catch (error) {
      console.error("Failed to read selected receipt image", error);
      this.setState({errorMessage:"Could not read the selected image. Please try another image."});
    }
  }
}

function mapStateToProps(state: any)
{
  const userId = state?.user?.session?.data?.id ?? 0;

  const family:IFamilyMember[] = Array.isArray(state?.family?.family) ? state.family.family : [];

  // Persisted state can hold null or old shapes here, so only trust arrays.
  let settings:IEcoSplitSetting[] = Array.isArray(state?.user?.splitSetting) ? state.user.splitSetting : [];

  let myPercentage = 50;
  if (settings.length === 0) {
    settings = [];
    settings.push({
      start:0,
      split: family.filter((mem) => mem.role === FamilyMemberType.PARENT).map((mem) => ({accountId:mem.id, percentage:50})),
    });
  } else {
    const lastSplit = settings[settings.length -1];
    for (const split of (lastSplit && Array.isArray(lastSplit.split) ? lastSplit.split : [])) {
      if (split && split.accountId === userId) {
        myPercentage = split.percentage;
      }
    }
  }

  const agreements:IEcoAgreement[] = state.economy.agreements;

  const purchases:IEcoPurchase[]   = state.economy.purchases;

  const transfers:IEcoTransfer[]   = state.economy.transfers;


  let totalBalance = 0;
  let prevMonthBalance = 0;
  const monthCutoff:Date = new Date();
  monthCutoff.setHours(0, 0, 0, 0);
  monthCutoff.setDate(1);
  const cutoffTime = monthCutoff.getTime();
 
  for (const purchase of purchases) {
    if (purchase.deleted === false && (purchase.disputedBy === undefined)) {
      const balance = getPurchaseBalance(purchase, userId, settings);
      totalBalance += balance;
      if (purchase.date < cutoffTime) {
        prevMonthBalance += balance;
      }
    }
  }

  if (transfers) {
    for (const transfer of transfers) {
      if (transfer.deleted === false && !transfer.disputedBy) {
        const balance = getTransferBalance(transfer, userId, settings);
        totalBalance += balance;
        if (getTransferBookingDate(transfer) < cutoffTime) {
            prevMonthBalance += balance;
        }  
      }
    }
  }

  const analyzedFiles:IAnalysedImage[] = (state.event.eventAnalyses?state.event.eventAnalyses:[])
    .filter((i: IAnalysedImage) => i.taskType === AI_ANALYZE_TASK_TYPE.RECEIPT);

  return {
    userId,
    familyKey: `${userId}:${state?.user?.session?.data?.resources?.[state?.user?.session?.selectedFamily ?? 0]?.id ?? ''}`,
    family,
    agreements,
    purchases,
    transfers,
    myPercentage,
    settings,
    currency:state.user.currency,
    swishF1: state.user.swishF1?state.user.swishF1:"",
    swishF2: state.user.swishF2?state.user.swishF2:"",
    venmoF1: state.user.venmoF1?state.user.venmoF1:"",
    venmoF2: state.user.venmoF2?state.user.venmoF2:"",
    cashappF1: state.user.cashappF1?state.user.cashappF1:"",
    cashappF2: state.user.cashappF2?state.user.cashappF2:"",
    paypalF1: state.user.paypalF1?state.user.paypalF1:"",
    paypalF2: state.user.paypalF2?state.user.paypalF2:"",
    shouldPay:((totalBalance < -50 && prevMonthBalance < -50)),
    // Older persisted state can hold null here, which passes the === undefined
    // check in render and crashes on .length — map it to undefined instead.
    paymentMethod: state.user.paymentMethod ? state.user.paymentMethod : undefined,

    uploadingFiles: state.file.uploadSlots,
    uploadedFiles: state.file.uploadedFiles,
    analyzedFiles,

  };
}

const mapDispatchToProps = {
  displaySuccessMessage: UserActions.displaySuccessMessage,
  displayErrorMessage: UserActions.displayErrorMessage,
  archiveAgreement: EconomyActions.archiveAgreement,
  archiveAgreementUpdate: EconomyActions.archiveAgreementUpdate,
  deletePurchase: EconomyActions.deletePurchase,
  restorePurchase: EconomyActions.restorePurchase,
  disputePurchase: EconomyActions.disputePurchase,
  endAgreement: EconomyActions.endAgreement,
  newAgreement: EconomyActions.newAgreement,
  newPurchase: EconomyActions.newPurchase,
  respondAgreement: EconomyActions.respondAgreement,
  respondAgreementUpdate: EconomyActions.respondAgreementUpdate,
  seenAgreement: EconomyActions.seenAgreement,
  seenPurchase: EconomyActions.seenPurchase,
  archivePurchase: EconomyActions.archivePurchase,
  updateAgreement: EconomyActions.updateAgreement,
  updatePurchase: EconomyActions.updatePurchase,

  newTransfer: EconomyActions.newTransfer,
  updateTransfer: EconomyActions.updateTransfer,
  deleteTransfer: EconomyActions.deleteTransfer,
  restoreTransfer: EconomyActions.restoreTransfer,
  archiveTransfer: EconomyActions.archiveTransfer,
  seenTransfer: EconomyActions.seenTransfer,
  updateEcoSettings: EconomyActions.updateEcoSettings,
  disputeTransfer: EconomyActions.disputeTransfer,

  uploadFile: FileActions.requestFileUpload,
  uploadedFileUsed: FileActions.uploadedFileUsed,
  analyzeImage : EventActions.analyzeReceiptImage,
  dismissAnalyzedImage : EventActions.dismissAnalyzedImage,

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(economyStyle)(EconomyContainer)));



// WEBPACK FOOTER //
// ./src/containers/economy/economy.container.tsx